var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BKButton',{staticClass:"csv-btn",attrs:{"white-text":""},on:{"click":_setup.downloadSCV}},[_vm._v(" Download CSV ")])
}
var staticRenderFns = []

export { render, staticRenderFns }